export default __webpack_public_path__ + "static/media/02_plane.5fe16cf4.gif";